import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router'
import { Web3Service } from 'app/services/web3/web3.service';
import { SimpleStorageService } from 'app/services/storage/simple-storage.service';
import { environment } from 'environments/environment';

declare const analytics

@Component({
  selector: 'app-find',
  templateUrl: './find.component.html',
  styleUrls: ['./find.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FindComponent implements OnInit {

  public elementsArray: any = []
  public specialityArray: any = []
  public selectedSpeciality
  public selectedElement
  public foundKryptomon: any = []
  public lookedKryptomon: any = []
  public allKryptomons: any = []
  public parsedKryptomon
  public isLoading
  public currentIndex
  public noKryptomons

  constructor(
    private http: HttpClient,
    private ref: ChangeDetectorRef,
    private router: Router,
    private simpleStorageService: SimpleStorageService,
    private web3Service: Web3Service,
  ) {
    this.parsedKryptomon = false;
    this.isLoading = false;
    this.currentIndex = 0;
    this.noKryptomons = false;
    this.elementsArray = [{ selected: false, type: "Fire", img: "./assets/img/icons/fire.svg" }, { selected: false, type: "Air", img: "./assets/img/icons/air.svg" }, { selected: false, type: "Grass", img: "./assets/img/icons/grass.svg" }, { selected: false, type: "Ice", img: "./assets/img/icons/ice.svg" }, { selected: false, type: "Electro", img: "./assets/img/icons/electro.svg" }, { selected: false, type: "Ghost", img: "./assets/img/icons/ghost.svg" }, { selected: false, type: "Ground", img: "./assets/img/icons/ground.svg" }, { selected: false, type: "Water", img: "./assets/img/icons/water.svg" },]
    this.specialityArray = [{ type: 'Attack', selected: false }, { type: 'Balance', selected: false }, { type: 'Defense', selected: false }]
  }

  ngOnInit(): void {
    analytics.track('started onboarding', {
      section: 'onboarding-premium', // or ‘onboarding-premium’
    });
  }

  selectElement(element, index) {
    for (let i = 0; i < this.elementsArray.length; i++) {
      if (i == index) {
        this.elementsArray[i].selected = true;
      } else {
        this.elementsArray[i].selected = false;
      }
    }
    this.selectedElement = element;
    analytics.track('clicked button', { section: 'onboarding-premium', value: element, step: 'step 1' });
    if (this.selectedElement !== undefined) {
      this.loadKryptomon();
    }

  }
  selectSpeciality(speciality, index) {
    for (let i = 0; i < this.specialityArray.length; i++) {
      if (i == index) {
        this.specialityArray[i].selected = true;
      } else {
        this.specialityArray[i].selected = false;
      }
    }
    this.selectedSpeciality = speciality
    analytics.track('clicked button', { section: 'onboarding-premium', value: speciality, step: 'step 1' });
    if (this.selectedSpeciality !== undefined && this.selectedElement !== undefined) {
      this.loadKryptomon();
    }
  }

  async loadKryptomon() {
    //this.loadingResult = true;
    //this.resultLoaded = false;
    this.isLoading = true;
    this.parsedKryptomon = false;
    this.currentIndex = 0;
    this.allKryptomons = []
    this.lookedKryptomon = []
    //+"&specialties="+this.selectedSpeciality
    await this.http.get(environment.nftServer + "v1/nfts?first=100&sortBy=newest&priceToken=usd,kmon&category=kryptomon&isOnSale=true&elemTypes=" + this.selectedElement, { headers: { skipInterceptor: "true" } }).subscribe((item: any) => {
      console.log(item)
      let lowestValue = Math.min(...item.data.map(o => o.order.priceUSD))
      console.log(lowestValue)

      for (let i = 0; i < item.data.length; i++) {
        if (item.data[i].order.priceUSD <= 100) {
          this.lookedKryptomon.push(item.data[i]);
        }
      }

      if (this.lookedKryptomon.length == 0) {
        for (let i = 0; i < item.data.length; i++) {
          if (item.data[i].order.priceUSD == lowestValue) {
            this.lookedKryptomon.push(item.data[i]);
          }
        }
      }

      console.log(this.lookedKryptomon)
      if (this.lookedKryptomon.length > 0) {
        this.getDetails(this.lookedKryptomon, 0)
      } else {
        this.noKryptomons = true;
        this.isLoading = false;
      }

    })
  }

  /*getDetailsNew(){
    for(let i = 0; i<1;i++){
      let item = this.lookedKryptomon[i];
      if(item.nft.data.kryptomon.status==0){

          var imageSelected

          if(item.nft.data.kryptomon.genes.xFactor==1){
            imageSelected = "super"
          }else{
            imageSelected = item.nft.data.kryptomon.speciality.toLowerCase()
          }

          if(item.extraData.unfreezable==1){
              item.nft.image ="./assets/img/top_special/" +item.nft.data.kryptomon.elementType +"/" +imageSelected +".png";
          }else{
              item.nft.image = "./assets/img/" +item.nft.data.kryptomon.elementType +"/" +imageSelected +".png";
          }
        }else if(item.status==1){
          item.nft.image = "https://kryptomon-images.ams3.digitaloceanspaces.com/images/kryptomons/png/kmon_"+item.nft.tokenId+"_png.png"
        }else if(item.status==2){
          item.nft.image = "https://kryptomon-images.ams3.digitaloceanspaces.com/images/kryptomons-junior/png/kmon_"+item.nft.tokenId+"_png.png"
        }


    }
  }*/

  /*async getDetails(item, i){
    console.log(i)
        await this.http.get("https://api-v22.kryptomon.co/kryptomon/"+item[i].nft.tokenId).subscribe((resp:any)=>{
          //this.wizardNfts[i].nft.ranking = resp.ranking;

          console.log(resp);
          
          if(resp.status==0){

          var imageSelected

          if(resp.genes.xFactor==1){
            imageSelected = "super"
          }else{
            imageSelected = resp.speciality.toLowerCase()
          }

          if(resp.extraData.unfreezable==1){
              item[i].nft.image ="./assets/img/top_special/" +resp.elementType +"/" +imageSelected +".png";
          }else{
              item[i].nft.image = "./assets/img/" +resp.elementType +"/" +imageSelected +".png";
          }
        }else if(resp.status==1){
          item[i].nft.image = "https://kryptomon-images.ams3.digitaloceanspaces.com/images/kryptomons/png/kmon_"+resp.tokenId+"_png.png"
        }else if(resp.status==2){
          item[i].nft.image = "https://kryptomon-images.ams3.digitaloceanspaces.com/images/kryptomons-junior/png/kmon_"+resp.tokenId+"_png.png"
        }

        item[i].nft.iconImage = "./assets/img/icons/" + resp.elementType.toLowerCase() + ".svg";
        item[i].nft.secondiconImage = "./assets/img/icons/" + resp.elementTypeSecond.toLowerCase() + ".svg";
        item[i].nft.ranking = resp.ranking;
        item[i].nft.elementType = resp.elementType;
        item[i].nft.elementTypeSecond = resp.elementTypeSecond;
        if(resp.gameMetadata){
          item[i].nft.isFreezed = resp.gameMetadata.isFreezed;
        }
        if(item[i].order.priceKMON==0 && item[i].order.paymentToken=="0xc732b6586a93b6b7cf5fed3470808bc74998224d"){
          item[i].order.priceKMON = parseFloat(this.appComponent.contractService.web3.utils.fromWei(item[i].order.price)).toLocaleString()
        }
        let stats:any = {}
        stats.physicalAttack = {name:'Physical Attack'};
        stats.physicalDefense = {name:'Physical Defense'};
        stats.mainElementalAttack = {name:resp.elementType + " Attack"};
        stats.secondaryElementalAttack = {name:resp.elementTypeSecond + " Attack"};
        stats.elementalDefense = {name:'Elemental Defense'};
        stats.healthPoints = {name:'Health Points'};
        stats.critical = {name:'Critical'};
        stats.evasion = {name:'Evasion'};

        console.log(stats.physicalAttack)
        stats.physicalAttack.value = parseInt(item[i].nft.data.kryptomon.genes.attack)
        stats.physicalDefense.value = (parseInt(item[i].nft.data.kryptomon.genes.defense) + parseInt(item[i].nft.data.kryptomon.genes.instinct)) / 2
        stats.mainElementalAttack.value = parseInt(resp.elementTalent)
        stats.secondaryElementalAttack.value = parseInt(resp.elementTalentSecond)
        stats.elementalDefense.value = (parseInt(item[i].nft.data.kryptomon.genes.defense) + parseInt(item[i].nft.data.kryptomon.genes.crazyness)) / 2
        stats.healthPoints.value = (parseInt(item[i].nft.data.kryptomon.genes.healthPoints) + parseInt(item[i].nft.data.kryptomon.genes.constitution)) / 2
        stats.critical.value = parseInt(item[i].nft.data.kryptomon.genes.crazyness)
        stats.evasion.value = parseInt(item[i].nft.data.kryptomon.genes.instinct)

        //let sumup = 0;

        for(let key in stats){
          if(key == "mainElementalAttack" || key == "secondaryElementalAttack"){
            if(stats[key].value<3600){
              stats[key].stars = 1;
            }else if(stats[key].value>=3600 && stats[key].value<=4224){
              stats[key].stars = 1.5;
            }else if(stats[key].value>=4225 && stats[key].value<=4899){
              stats[key].stars = 2;
            }else if(stats[key].value>=4900 && stats[key].value<=5264){
              stats[key].stars = 2.5;
            }else if(stats[key].value>=5265 && stats[key].value<=6399){
              stats[key].stars = 3;
            }else if(stats[key].value>=6400 && stats[key].value<=7224){
              stats[key].stars = 3.5;
            }else if(stats[key].value>=7225 && stats[key].value<=8099){
              stats[key].stars = 4;
            }else if(stats[key].value>=8100 && stats[key].value<=9024){
              stats[key].stars = 4.5;
            }else{
              stats[key].stars = 5;
            }
          }else{
            if(stats[key].value<60){
              stats[key].stars = 1;
            }else if(stats[key].value>=60 && stats[key].value<=64){
              stats[key].stars = 1.5;
            }else if(stats[key].value>=65 && stats[key].value<=69){
              stats[key].stars = 2;
            }else if(stats[key].value>=70 && stats[key].value<=74){
              stats[key].stars = 2.5;
            }else if(stats[key].value>=75 && stats[key].value<=79){
              stats[key].stars = 3;
            }else if(stats[key].value>=80 && stats[key].value<=84){
              stats[key].stars = 3.5;
            }else if(stats[key].value>=85 && stats[key].value<=89){
              stats[key].stars = 4;
            }else if(stats[key].value>=90 && stats[key].value<=94){
              stats[key].stars = 4.5;
            }else{
              stats[key].stars = 5;
            }
          }
          //sumup = sumup + stats[key].stars;
        }

        if(item[i].nft.ranking<650){
          stats.tier = "Rookie"
        }else if(item[i].nft.ranking>=650 && item[i].nft.ranking<700){
          stats.tier = "Veteran"
        }else{
          stats.tier = "Elite"
        }
        

          item[i].nft.stats = stats;

          
          this.allKryptomons.push(item[i]);
          if(i<item.length-1){
            i++;
            this.getDetails(item,i++)
          }else{
            console.log(this.allKryptomons)
            this.allKryptomons.sort((a,b) => a.order.priceUSD - b.order.priceUSD)
            this.foundKryptomon = this.allKryptomons[0]
            this.parsedKryptomon = true;
            this.isLoading = false;
            console.log(this.foundKryptomon)
            this.ref.detectChanges();
        }
    },(err)=>{
      if(i<item.length-1){
            i++;
            this.getDetails(item,i++)
          }else{
           this.allKryptomons.sort((a,b) => a.order.priceUSD - b.order.priceUSD)
           this.foundKryptomon = this.allKryptomons[0]
           this.parsedKryptomon = true;
           this.isLoading = false;
           this.ref.detectChanges();
            
        }
    })
      
  }*/

  async getDetails(item, i) {
    console.log(item)
    for (let i = 0; i < item.length; i++) {
      var resp = item[i].nft.data.kryptomon
      console.log(resp);

      if (resp.status == 0) {

        var imageSelected

        if (resp.genes.xFactor == 1) {
          imageSelected = "super"
        } else {
          imageSelected = resp.speciality.toLowerCase()
        }

        if (resp.extraData.unfreezable == 1) {
          item[i].nft.image = "./assets/img/top_special/" + resp.elementType + "/" + imageSelected + ".png";
        } else {
          item[i].nft.image = "./assets/img/" + resp.elementType + "/" + imageSelected + ".png";
        }
      } else if (resp.status == 1) {
        item[i].nft.image = "https://kryptomon-images.ams3.digitaloceanspaces.com/images/kryptomons/png/kmon_" + item[i].nft.tokenId + "_png.png"
      } else if (resp.status == 2) {
        item[i].nft.image = "https://kryptomon-images.ams3.digitaloceanspaces.com/images/kryptomons-junior/png/kmon_" + item[i].nft.tokenId + "_png.png"
      }

      item[i].nft.iconImage = "./assets/img/icons/" + resp.elementType.toLowerCase() + ".svg";
      item[i].nft.secondiconImage = "./assets/img/icons/" + resp.elementTypeSecond.toLowerCase() + ".svg";
      item[i].nft.ranking = resp.ranking;
      item[i].nft.elementType = resp.elementType;
      item[i].nft.elementTypeSecond = resp.elementTypeSecond;
      if (resp.gameMetadata) {
        item[i].nft.isFreezed = resp.gameMetadata.isFreezed;
      }
      if (item[i].order.priceKMON == 0 && item[i].order.paymentToken == "0xc732b6586a93b6b7cf5fed3470808bc74998224d") {
        item[i].order.priceKMON = parseFloat(this.web3Service.getWeb3().utils.fromWei(item[i].order.price)).toLocaleString()
      }
      let stats: any = {}
      stats.physicalAttack = { name: 'Physical Attack' };
      stats.physicalDefense = { name: 'Physical Defense' };
      stats.mainElementalAttack = { name: resp.elementType + " Attack" };
      stats.secondaryElementalAttack = { name: resp.elementTypeSecond + " Attack" };
      stats.elementalDefense = { name: 'Elemental Defense' };
      stats.healthPoints = { name: 'Health Points' };
      stats.critical = { name: 'Critical' };
      stats.evasion = { name: 'Evasion' };

      console.log(stats.physicalAttack)
      stats.physicalAttack.value = parseInt(item[i].nft.data.kryptomon.genes.attack)
      stats.physicalDefense.value = (parseInt(item[i].nft.data.kryptomon.genes.defense) + parseInt(item[i].nft.data.kryptomon.genes.instinct)) / 2
      stats.mainElementalAttack.value = parseInt(resp.elementTalent)
      stats.secondaryElementalAttack.value = parseInt(resp.elementTalentSecond)
      stats.elementalDefense.value = (parseInt(item[i].nft.data.kryptomon.genes.defense) + parseInt(item[i].nft.data.kryptomon.genes.crazyness)) / 2
      stats.healthPoints.value = (parseInt(item[i].nft.data.kryptomon.genes.healthPoints) + parseInt(item[i].nft.data.kryptomon.genes.constitution)) / 2
      stats.critical.value = parseInt(item[i].nft.data.kryptomon.genes.crazyness)
      stats.evasion.value = parseInt(item[i].nft.data.kryptomon.genes.instinct)

      //let sumup = 0;

      for (let key in stats) {
        if (key == "mainElementalAttack" || key == "secondaryElementalAttack") {
          if (stats[key].value < 3600) {
            stats[key].stars = 1;
          } else if (stats[key].value >= 3600 && stats[key].value <= 4224) {
            stats[key].stars = 1.5;
          } else if (stats[key].value >= 4225 && stats[key].value <= 4899) {
            stats[key].stars = 2;
          } else if (stats[key].value >= 4900 && stats[key].value <= 5264) {
            stats[key].stars = 2.5;
          } else if (stats[key].value >= 5265 && stats[key].value <= 6399) {
            stats[key].stars = 3;
          } else if (stats[key].value >= 6400 && stats[key].value <= 7224) {
            stats[key].stars = 3.5;
          } else if (stats[key].value >= 7225 && stats[key].value <= 8099) {
            stats[key].stars = 4;
          } else if (stats[key].value >= 8100 && stats[key].value <= 9024) {
            stats[key].stars = 4.5;
          } else {
            stats[key].stars = 5;
          }
        } else {
          if (stats[key].value < 60) {
            stats[key].stars = 1;
          } else if (stats[key].value >= 60 && stats[key].value <= 64) {
            stats[key].stars = 1.5;
          } else if (stats[key].value >= 65 && stats[key].value <= 69) {
            stats[key].stars = 2;
          } else if (stats[key].value >= 70 && stats[key].value <= 74) {
            stats[key].stars = 2.5;
          } else if (stats[key].value >= 75 && stats[key].value <= 79) {
            stats[key].stars = 3;
          } else if (stats[key].value >= 80 && stats[key].value <= 84) {
            stats[key].stars = 3.5;
          } else if (stats[key].value >= 85 && stats[key].value <= 89) {
            stats[key].stars = 4;
          } else if (stats[key].value >= 90 && stats[key].value <= 94) {
            stats[key].stars = 4.5;
          } else {
            stats[key].stars = 5;
          }
        }
        //sumup = sumup + stats[key].stars;
      }


      if (item[i].ranking < 650) {
        stats.tier = "Rookie"
      } else if (item[i].ranking >= 650 && item[i].ranking < 700) {
        stats.tier = "Veteran"
      } else if (item[i].ranking >= 700 && item[i].ranking < 775) {
        stats.tier = "Elite"
      } else {
        stats.tier = "Hero"
      }


      item[i].nft.stats = stats;


      this.allKryptomons.push(item[i]);
    }
    console.log(this.allKryptomons)
    this.allKryptomons.sort((a, b) => a.order.priceUSD - b.order.priceUSD)
    this.foundKryptomon = this.allKryptomons[0]
    this.parsedKryptomon = true;
    this.isLoading = false;
    console.log(this.foundKryptomon)
    this.ref.detectChanges();

  }

  nextKryptomon() {
    this.currentIndex++;
    this.foundKryptomon = this.allKryptomons[this.currentIndex];
  }

  backKryptomon() {
    this.currentIndex--;
    this.foundKryptomon = this.allKryptomons[this.currentIndex];
  }

  selectKryptomon() {
    analytics.track('selected kryptomon', {
      section: 'onboarding-premium',
      mainElement: this.foundKryptomon.nft.elementType,
      specialty: this.foundKryptomon.nft.data.kryptomon.speciality,
      productID: this.foundKryptomon.nft.tokenId,
      price: this.foundKryptomon.order.priceUSD, // dollar
      rank: this.foundKryptomon.nft.stats.tier, // stars
      step: 'step 1'
    });
    analytics.track('clicked button', { section: 'onboarding-premium', value: "select", step: 'step 1' });
    this.simpleStorageService.setSimple('foundKryptomon', this.foundKryptomon);
    this.router.navigate(['/onboarding/first-lootbox'])
  }
}
